exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.book-component-list-folder__header {\n  cursor: pointer;\n  display: flex;\n}\n.book-component-list-folder__header__caret {\n    flex: 0 0 14px;\n    width: 14px;\n    width: 14px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n.book-component-list-folder__header__icon {\n    flex: 0 0 18px;\n    height: 18px;\n    width: 18px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: #656192;\n    margin-left: 3px;\n    margin-right: 3px;\n}\n.book-component-list-folder__insides {\n  padding-left: 16px;\n}\n", ""]);

// exports
